var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatriaLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsX: "&ns_extend;",
    xmlnsI: "&ns_ai;",
    xmlnsGraph: "&ns_graphs;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsA: "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    x: "0px",
    y: "0px",
    width: "90px",
    height: "78px",
    viewBox: "0 0 90 78",
    enableBackground: "new 0 0 90 78",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "23.6,73.2 30.9,60.4 16.2,60.4 23.6,47.7 1.5,47.7 12.4,28.7 23.6,28.7 16.2,15.9 31,15.9 23.6,3.1 63.9,3.1 56.5,15.9 71.3,15.9 63.9,28.7 75,28.7 86.1,47.7 63.9,47.7 71.3,60.4 56.5,60.4 63.9,73.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#911F89",
    points: "43.7,44.6 51.1,57.3 58.5,70.1 43.7,70.1 29,70.1 36.4,57.3 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EABD26",
    points: "43.7,31.8 36.4,19 29,6.3 43.7,6.3 58.5,6.3 51.1,19 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6EAD3B",
    points: "58.5,31.8 43.7,31.8 51.1,19 65.8,19 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C22821",
    points: "36.4,44.6 6.9,44.6 14.2,31.8 43.7,31.8 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E76727",
    points: "29,31.8 43.7,31.8 36.4,19 21.6,19 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#009479",
    points: "51.1,44.6 80.6,44.6 73.2,31.8 43.7,31.8 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C84378",
    points: "29,44.6 43.7,44.6 36.4,57.3 21.6,57.3 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0081C6",
    points: "58.5,44.6 43.7,44.6 51.1,57.3 65.8,57.3 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#001C85",
    points: "58.5,31.8 43.8,31.8 29,31.8 21.7,44.6 43.8,44.6 65.9,44.6 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#001C85",
    points: "51.2,19 43.8,19 36.4,19 40.1,25.4 43.8,31.8 47.5,25.4 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#001C85",
    points: "36.4,57.3 51.2,57.3 43.8,44.6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatriaLogoIcon);
export default __webpack_public_path__ + "static/media/patria_logo_icon.890be7cf91139afb0fbb2261dc56ae0f.svg";
export { ForwardRef as ReactComponent };